'use strict';

var GridToolbarSystemStatusDemandReinitializationDirective = function GridToolbarSystemStatusDemandReinitializationDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-system-status-demand-reinitialization.html'),
    controller: 'GridToolbarSystemStatusDemandReinitializationController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        scope.onRowSelection(selectedRows);
      });
    }
  };
};
GridToolbarSystemStatusDemandReinitializationDirective.$inject = [];
module.exports = GridToolbarSystemStatusDemandReinitializationDirective;